// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WXLogin_container__\\+xHMQ {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 178px;
    height: 50px;
    padding: 0 10px;
    border: 1px solid #ebedf0;
    border-radius: 6px;
    transition: 0.5s;
}

.WXLogin_container__\\+xHMQ:hover {
    cursor: pointer;
    background-color: #e4f0f2;
}

.WXLogin_container__\\+xHMQ:active {
    background-color: #74bdc6;
}

.WXLogin_img__Kd3YU {
    width: 32px;
    height: 32px;
}

.WXLogin_text__Fu0do {
    font-size: 14px;
    color: #7E8B9E;
    transition: 0.5s;
}

.WXLogin_container__\\+xHMQ:active .WXLogin_text__Fu0do {
    color: #f2f8f9;
}`, "",{"version":3,"sources":["webpack://./src/pages/login/components/WXLogin/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".container {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    width: 178px;\n    height: 50px;\n    padding: 0 10px;\n    border: 1px solid #ebedf0;\n    border-radius: 6px;\n    transition: 0.5s;\n}\n\n.container:hover {\n    cursor: pointer;\n    background-color: #e4f0f2;\n}\n\n.container:active {\n    background-color: #74bdc6;\n}\n\n.img {\n    width: 32px;\n    height: 32px;\n}\n\n.text {\n    font-size: 14px;\n    color: #7E8B9E;\n    transition: 0.5s;\n}\n\n.container:active .text {\n    color: #f2f8f9;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `WXLogin_container__+xHMQ`,
	"img": `WXLogin_img__Kd3YU`,
	"text": `WXLogin_text__Fu0do`
};
export default ___CSS_LOADER_EXPORT___;
